import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQueries } from 'src/client/js/view/hooks';
import Accordion, { AccordionItem } from 'wonderbly-components/lib/Accordion';
import FooterLinks from './FooterLinks';
import PaymentIcons from '../PaymentIcons';
import SocialNetworkSet from './SocialNetworkSet';
import FooterSub from './FooterSub';
import TrustpilotWidget from '../TrustpilotWidget';

import './FooterII.scss';

const FooterII = props => {
  const mobile = useMediaQueries('mobile');

  return (
    <footer className="SiteFooter"> 
      <div className="SiteFooter__container container-guttered">
        <div className="SiteFooter__links">
          {props.columns.map((list, colIndex) => (
            <div
              key={colIndex}
              className="SiteFooter__column">
              {list.map((linkSet, linkSetIndex) => (
                <nav
                  key={linkSetIndex}
                  className="SiteFooter__list">
                  {mobile || linkSet.collapsedOnDesktop === true ? (
                    <Accordion
                      invert
                      closeOtherItems>
                      <AccordionItem
                        key={linkSet.title}
                        header={<h3>{linkSet.title}</h3>}>
                        <FooterLinks links={linkSet} />
                      </AccordionItem>
                    </Accordion>
                  ) : (
                    <>
                      <h3 className="SiteFooter__list-title">
                        {linkSet.title}
                      </h3>
                      <FooterLinks links={linkSet} />
                    </>
                  )}
                </nav>
              ))}
            </div>
          ))}
        </div>
        <div className="SiteFooter__widget-col">
          <TrustpilotWidget
            templateId="microstar"
            className="SiteFooter__trustpilot-micro-star"
            theme="dark"
            isComponent={false}
          />
          <PaymentIcons
            className="SiteFooter__payment-icons"
          />
          <SocialNetworkSet
            socialNetworks={props.socialNetworks}
          />
        </div>
      </div>
      <FooterSub
        companyLinks={props.companyLinks}
      />
    </footer>
  );
};

FooterII.defaultProps = {
  columns: [],
};

FooterII.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.array).isRequired,
  collapsedOnDesktop: PropTypes.bool,    
  socialNetworks: PropTypes.arrayOf(PropTypes.array).isRequired,
  companyLinks: PropTypes.arrayOf(PropTypes.array).isRequired,
};  

export default FooterII;
